import { ESutochnoPilotStatus, ISutochnoPilotState } from '../../types/sutochnoPilot';

export const defaultState: ISutochnoPilotState = {
  status: ESutochnoPilotStatus.Initial,
  isPilotEnabled: false,
  regions: [],
};
